/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 1 = Schedule Item

2 = Workday Exception

4 = Shift Entire Schedule

5 = Bulk Delete

6 = Set Schedule Online

7 = Set Schedule Offline

8 = Draft Schedule Update

9 = Deleted Item


 */
export type ModifyCalendarEnum =
  (typeof ModifyCalendarEnum)[keyof typeof ModifyCalendarEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModifyCalendarEnum = {
  Schedule_Item: 1,
  Workday_Exception: 2,
  EntireSchedule: 4,
  BulkDelete: 5,
  ScheduleOnline: 6,
  ScheduleOffline: 7,
  DraftScheduleUpdate: 8,
  DeletedItem: 9,
} as const;
